import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Button, Form, Table, InputGroup, Badge, Modal } from 'react-bootstrap';
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';
import vietnamAddressData from '../utils/vietnamAddressBefore2024.json';
import queryString from 'query-string';
import Pagination from 'components/Pagination';
import { getTKT1TrustedPersonInfos, updateTKT1TrustedPersonInfo, createTKT1TrustedPersonInfo } from 'actions/tkt1TrustedPersonAction';
import Select from 'react-select';
import TrustedPersonInfoModal from '../components/TrustedPersonInfoModal/TrustedPersonInfoModal';
import IframeModal from '../components/IframeModal/IframeModal';
import { getApiUrl } from '../utils/platform';
import { getToken } from '../utils/token';

class TKT1TrustedPerson extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'MID',
    sortOrder: 1,
    search: '',
    search_exact: false,
    relation_with: '',
    c3d_city: '',
    current_city: '',
    status: ''
  }

  initShowColumns = {
    MID: true,
    full_name: true,
    full_name_english: false,
    is_registered_etsy: true,
    relation_with: false,
    relation_note: true,
    c3d_number: false,
    c3d_dob: false,
    c3d_sex: false,
    c3d_place_of_origin: false,
    c3d_place_of_residence: false,
    c3d_city: true,
    c3d_photos: false,
    c3d_metadata: false,
    address: false,
    phone: false,
    contact_note: false,
    current_city: true,
    is_deleted: false,
    created_at: false,
    updated_at: false,
    scan_progress: true
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      search_exact: false,
      showEditModal: false,
      showViewModal: false,
      showCreateModal: false,
      selectedTrustedPersonInfo: null,
      isEditMode: false,
      isCreateMode: false,
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Trusted Person';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    var itemsPerPage = urlParams.get('itemsPerPage');

    if (itemsPerPage) {
      const queryObject = queryString.parse(queryStringFromUrl);
      ['itemsPerPage', 'currentPage'].map(key => {
        queryObject[key] = parseInt(queryObject[key])
      })
      queryObject.sortOrder = parseInt(queryObject.sortOrder || this.initQuery.sortOrder);
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1TrustedPerson_ViewConfig'));
      const searchExact = JSON.parse(localStorage.getItem('TKT1TrustedPerson_search_exact')) || false;
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        search_exact: searchExact
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1TrustedPersonInfos(apiQuery);
      })
    } else {
      var query = JSON.parse(localStorage.getItem('tkt1_trusted_person_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1TrustedPerson_ViewConfig'));
      var searchExact = JSON.parse(localStorage.getItem('TKT1TrustedPerson_search_exact')) || false;
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          search_exact: searchExact
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1TrustedPersonInfos(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          search_exact: searchExact
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1TrustedPersonInfos(apiQuery);
        })
      }
    }
  }

  componentWillReceiveProps(props) {
    // No need to update state since we're using props directly
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }


  handleSearchExactChange = (e) => {
    const searchExact = e.target.checked;
    this.setState({ search_exact: searchExact });
    localStorage.setItem('TKT1TrustedPerson_search_exact', JSON.stringify(searchExact));
  }

  handleRelationChange = (e) => {
    const newQuery = { ...this.state.query, relation_with: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_trusted_person_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      relation_with: newQuery.relation_with,
      c3d_city: this.state.query.c3d_city,
      current_city: this.state.query.current_city,
      status: this.state.query.status
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1TrustedPersonInfos(apiQuery);
  }

  handleC3DCityChange = (selectedOption) => {
    const newQuery = { 
      ...this.state.query, 
      c3d_city: selectedOption ? selectedOption.value : '' 
    };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_trusted_person_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      relation_with: this.state.query.relation_with,
      c3d_city: newQuery.c3d_city,
      current_city: this.state.query.current_city,
      status: this.state.query.status
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1TrustedPersonInfos(apiQuery);
  }

  handleCurrentCityChange = (selectedOption) => {
    const newQuery = { 
      ...this.state.query, 
      current_city: selectedOption ? selectedOption.value : '' 
    };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_trusted_person_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      relation_with: this.state.query.relation_with,
      c3d_city: this.state.query.c3d_city,
      current_city: newQuery.current_city,
      status: this.state.query.status
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1TrustedPersonInfos(apiQuery);
  }

  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_trusted_person_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const trimmedQuery = {
      ...newQuery,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      relation_with: this.state.query.relation_with,
      c3d_city: this.state.query.c3d_city,
      current_city: this.state.query.current_city,
      status: newQuery.status
    };
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    this.updateUrl(trimmedQuery);
    this.props.getTKT1TrustedPersonInfos(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config separately - not related to query
      localStorage.setItem('TKT1TrustedPerson_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Map gender from English to Vietnamese
  mapGender = (gender) => {
    if (!gender) return '-';
    switch (gender.toUpperCase()) {
      case 'MALE':
        return 'Nam';
      case 'FEMALE':
        return 'Nữ';
      default:
        return gender;
    }
  }

  // Calculate scan progress percentage
  calculateScanProgress = (matching_c3d_tax_total, matching_c3d_total) => {
    if (!matching_c3d_total || matching_c3d_total === 0) return '0%';
    const percentage = Math.round((matching_c3d_tax_total / matching_c3d_total) * 100);
    return `${percentage}%`;
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      // You could add a toast notification here if needed
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Open C3D database search link in iframe modal
  openC3DSearchLink = (fullNameEnglish, mid) => {
    if (fullNameEnglish) {
      const encodedName = encodeURIComponent(fullNameEnglish);
      const url = `/admin/tkt1/c3d-database?search=${encodedName}&search_exact=true&ref_trusted_person_mid=${mid}`;
      this.setState({
        showIframeModal: true,
        iframeUrl: url,
        iframeTitle: `C3D Database Search - ${fullNameEnglish}`
      });
    }
  }

  // Modal handlers
  handleViewClick = (trustedPersonInfo) => {
    this.setState({
      showViewModal: true,
      selectedTrustedPersonInfo: trustedPersonInfo,
      isEditMode: false
    });
  }

  handleEditClick = (trustedPersonInfo) => {
    this.setState({
      showEditModal: true,
      selectedTrustedPersonInfo: trustedPersonInfo,
      isEditMode: true,
      isCreateMode: false
    });
  }

  handleCreateClick = () => {
    this.setState({
      showCreateModal: true,
      selectedTrustedPersonInfo: {
        MID: '',
        full_name: '',
        full_name_english: '',
        relation_with: '',
        relation_note: '',
        c3d_number: '',
        c3d_dob: '',
        c3d_city: '',
        c3d_place_of_origin: '',
        c3d_place_of_residence: '',
        address: '',
        phone: '',
        current_city: '',
        contact_note: '',
        is_registered_etsy: false,
        status: 'draft'
      },
      isEditMode: false,
      isCreateMode: true
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedTrustedPersonInfo: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedTrustedPersonInfo: null,
      isEditMode: false,
      isCreateMode: false
    });
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      selectedTrustedPersonInfo: null,
      isEditMode: false,
      isCreateMode: false
    });
  }

  handleSaveEdit = async (formData) => {
    try {
      const { selectedTrustedPersonInfo, isCreateMode } = this.state;
      
      if (isCreateMode) {
        // Validate required fields for creation
        if (!formData.MID || !formData.MID.trim()) {
          alert('Vui lòng nhập MID để tạo mới Trusted Person');
          return;
        }

        if (!formData.full_name || !formData.full_name.trim()) {
          alert('Vui lòng nhập tên đầy đủ để tạo mới Trusted Person');
          return;
        }

        // Create new trusted person
        const createData = {
          MID: formData.MID.trim(),
          full_name: formData.full_name.trim(),
          full_name_english: formData.full_name_english,
          relation_with: formData.relation_with,
          relation_note: formData.relation_note,
          c3d_number: formData.c3d_number,
          c3d_dob: formData.c3d_dob,
          c3d_city: formData.c3d_city,
          c3d_place_of_origin: formData.c3d_place_of_origin,
          c3d_place_of_residence: formData.c3d_place_of_residence,
          address: formData.address,
          phone: formData.phone,
          current_city: formData.current_city,
          contact_note: formData.contact_note,
          is_registered_etsy: formData.is_registered_etsy,
          status: formData.status
        };

        // Call the create action
        await this.props.createTKT1TrustedPersonInfo(createData);
        
        // Show success message
        alert('Tạo mới Trusted Person thành công!');
        
        // Close modal
        this.handleCloseCreateModal();
      } else {
        // Update existing trusted person
        if (!selectedTrustedPersonInfo || !selectedTrustedPersonInfo._id) {
          alert('Không tìm thấy thông tin Trusted Person để cập nhật');
          return;
        }

        // Prepare update data - include all editable fields
        const updateData = {
          full_name: formData.full_name,
          full_name_english: formData.full_name_english,
          relation_with: formData.relation_with,
          relation_note: formData.relation_note,
          c3d_number: formData.c3d_number,
          c3d_dob: formData.c3d_dob,
          c3d_city: formData.c3d_city,
          c3d_place_of_origin: formData.c3d_place_of_origin,
          c3d_place_of_residence: formData.c3d_place_of_residence,
          address: formData.address,
          phone: formData.phone,
          current_city: formData.current_city,
          contact_note: formData.contact_note,
          is_registered_etsy: formData.is_registered_etsy,
          status: formData.status
        };

        // Call the update action
        await this.props.updateTKT1TrustedPersonInfo(selectedTrustedPersonInfo._id, updateData);
        
        // Show success message
        alert('Cập nhật thông tin Trusted Person thành công!');
        
        // Close modal
        this.handleCloseEditModal();
      }
      
      // Refresh the data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1TrustedPersonInfos(apiQuery);
      
    } catch (error) {
      console.error('Error saving trusted person:', error);
      alert('Lỗi khi lưu thông tin Trusted Person: ' + (error.message || 'Unknown error'));
    }
  }

  // Update all Trusted Person status
  handleUpdateAllTrustedPersonStatus = async () => {
    const { trustedPersonInfos } = this.props;
    
    if (!trustedPersonInfos || trustedPersonInfos.length === 0) {
      alert('Không có dữ liệu Trusted Person để cập nhật');
      return;
    }

    const confirmUpdate = window.confirm(
      `Bạn có chắc chắn muốn cập nhật trạng thái cho tất cả ${trustedPersonInfos.length} Trusted Person?`
    );
    
    if (!confirmUpdate) return;

    try {
      const token = getToken();
      let successCount = 0;
      let errorCount = 0;
      const errors = [];

      // Process each trusted person
      for (const trustedPerson of trustedPersonInfos) {
        try {
          // Get C3D data for this trusted person using full_name_english
          const searchName = encodeURIComponent(trustedPerson.full_name_english || '');
          const c3dResponse = await fetch(`${getApiUrl()}/api/tkt1-c3d-info/get?currentPage=1&itemsPerPage=9999&sortBy=created_at&sortOrder=-1&search=${searchName}&search_exact=true`, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          if (!c3dResponse.ok) {
            throw new Error(`Failed to fetch C3D data for ${trustedPerson.full_name_english}`);
          }

          const c3dData = await c3dResponse.json();
          const c3dInfos = c3dData.data?.result || [];

          // Calculate totals
          const matching_c3d_total = c3dInfos.length;
          const matching_c3d_tax_total = c3dInfos.filter(info => {
            // Check if DN_tax_infos or TNCN_tax_infos is not empty
            const hasDNTax = info.DN_tax_infos && Array.isArray(info.DN_tax_infos) && info.DN_tax_infos.length > 0;
            const hasTNCNTax = info.TNCN_tax_infos && Array.isArray(info.TNCN_tax_infos) && info.TNCN_tax_infos.length > 0;
            return hasDNTax || hasTNCNTax;
          }).length;

          // Update trusted person
          const updateResponse = await fetch(`${getApiUrl()}/api/tkt1-trusted-person-info/mid/${trustedPerson.MID}`, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              matching_c3d_total,
              matching_c3d_tax_total
            })
          });

          if (updateResponse.ok) {
            successCount++;
          } else {
            const errorData = await updateResponse.json();
            throw new Error(errorData.message || 'Update failed');
          }
        } catch (error) {
          errorCount++;
          errors.push(`MID ${trustedPerson.MID}: ${error.message}`);
        }
      }

      // Show results
      if (errorCount === 0) {
        alert(`Cập nhật thành công cho tất cả ${successCount} Trusted Person!`);
        // Refresh data
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1TrustedPersonInfos(apiQuery);
      } else {
        alert(`Cập nhật hoàn tất!\nThành công: ${successCount}\nLỗi: ${errorCount}\n\nChi tiết lỗi:\n${errors.slice(0, 5).join('\n')}${errors.length > 5 ? '\n...' : ''}`);
      }
    } catch (error) {
      console.error('Error updating all trusted person status:', error);
      alert('Lỗi khi cập nhật trạng thái tất cả Trusted Person');
    }
  }

  // Helper function to prepare API query (remove showColumns and only include search_exact if explicitly enabled)
  prepareApiQuery = (query) => {
    const { showColumns, search, relation_with, c3d_city, current_city, status, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add relation filter if selected
    if (relation_with && relation_with.trim()) {
      apiQuery.relation_with = relation_with;
    }
    
    // Add city filters if selected
    if (c3d_city && c3d_city.trim()) {
      apiQuery.c3d_city = c3d_city;
    }
    
    if (current_city && current_city.trim()) {
      apiQuery.current_city = current_city;
    }
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    // Only add search_exact if user explicitly enabled it
    if (search && search.trim() && this.state.search_exact === true) {
      apiQuery.search_exact = true;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      relation_with: this.state.query.relation_with,
      c3d_city: this.state.query.c3d_city,
      current_city: this.state.query.current_city,
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1TrustedPersonInfos(apiQuery);
      localStorage.setItem('tkt1_trusted_person_query', JSON.stringify(trimmedQuery));
    })
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1/trusted-person',
      search: queryStr,
    });
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    // Trim search value before sending to API
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      relation_with: this.state.query.relation_with,
      c3d_city: this.state.query.c3d_city,
      current_city: this.state.query.current_city,
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery)
    this.props.getTKT1TrustedPersonInfos(apiQuery);
    localStorage.setItem('tkt1_trusted_person_query', JSON.stringify(trimmedQuery));
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim(),
      search_exact: this.state.search_exact,
      relation_with: this.state.query.relation_with,
      c3d_city: this.state.query.c3d_city,
      current_city: this.state.query.current_city,
      status: this.state.query.status
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ trustedPersonInfos: [] }, () => {
        this.updateUrl(trimmedQuery)
        this.props.getTKT1TrustedPersonInfos(apiQuery);
        localStorage.setItem('tkt1_trusted_person_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    })
  }

  renderSearchFilter = () => {
    // Prepare city options for react-select
    const cityOptions = vietnamAddressData.map((province) => {
      const cleanDisplayName = province.Name
        .replace(/^Tỉnh\s+/, '')
        .replace(/^Thành phố\s+/, '')
        .trim();
      
      return {
        value: cleanDisplayName,
        label: cleanDisplayName
      };
    });

    return <>
      <Row className="mb-3">
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tên, MID, số C3D..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Đầu mối</InputGroup.Text>
            <Form.Select
              value={this.state.query.relation_with}
              onChange={this.handleRelationChange}
            >
              <option value="">Tất cả</option>
              <option value="Nguyễn Việt Anh">NVA</option>
              <option value="Đinh Công Trường">DCT</option>
              <option value="Vũ Phương Thảo">VPT</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="deactive">Deactive</option>
              <option value="draft">Draft</option>
              <option value="publish">Publish</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <div style={{ position: 'relative' }}>
            <Select
              value={cityOptions.find(option => option.value === this.state.query.c3d_city) || null}
              onChange={this.handleC3DCityChange}
              options={cityOptions}
              placeholder="C3D Thành phố..."
              isClearable
              isSearchable
              noOptionsMessage={() => "Không tìm thấy"}
              filterOption={(option, inputValue) => {
                const searchTerm = inputValue.toLowerCase();
                const label = option.data.label ? option.data.label.toLowerCase() : '';
                return label.includes(searchTerm);
              }}
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: '38px',
                  fontSize: '0.875rem'
                }),
                container: (provided) => ({
                  ...provided,
                  flex: 1
                })
              }}
            />
          </div>
        </Col>
        <Col md="2">
          <div style={{ position: 'relative' }}>
            <Select
              value={cityOptions.find(option => option.value === this.state.query.current_city) || null}
              onChange={this.handleCurrentCityChange}
              options={cityOptions}
              placeholder="Thành phố hiện tại..."
              isClearable
              isSearchable
              noOptionsMessage={() => "Không tìm thấy"}
              filterOption={(option, inputValue) => {
                const searchTerm = inputValue.toLowerCase();
                const label = option.data.label ? option.data.label.toLowerCase() : '';
                return label.includes(searchTerm);
              }}
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: '38px',
                  fontSize: '0.875rem'
                }),
                container: (provided) => ({
                  ...provided,
                  flex: 1
                })
              }}
            />
          </div>
        </Col>
        <Col md="2" className="d-flex align-items-center">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderTrustedPersonTable = () => {
    const { trustedPersonInfos } = this.props; // Use props from Redux instead of state
    const { showColumns } = this.state; // Use separate showColumns state
    
    // Ensure trustedPersonInfos is an array and filter out any null/undefined items
    const safeTrustedPersonInfos = Array.isArray(trustedPersonInfos) ? trustedPersonInfos.filter(info => info != null && typeof info === 'object') : [];
    
    // Calculate total percentages for scan progress
    const totalMatchingC3D = safeTrustedPersonInfos.reduce((sum, info) => sum + (info.matching_c3d_total || 0), 0);
    const totalMatchingC3DTax = safeTrustedPersonInfos.reduce((sum, info) => sum + (info.matching_c3d_tax_total || 0), 0);
    const totalPercentage = totalMatchingC3D > 0 ? Math.round((totalMatchingC3DTax / totalMatchingC3D) * 100) : 0;
    
    // Early return if no data to prevent any rendering issues
    if (!safeTrustedPersonInfos || safeTrustedPersonInfos.length === 0) {
      return (
        <Table striped bordered hover style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.MID && <th>MID</th>}
              {showColumns.full_name && <th>Tên đầy đủ</th>}
              {showColumns.full_name_english && <th>Tên tiếng Anh</th>}
              {showColumns.is_registered_etsy && <th>Trạng thái Etsy</th>}
              {showColumns.relation_with && <th>Đầu mối</th>}
              {showColumns.relation_note && <th>Ghi chú quan hệ</th>}
              {showColumns.c3d_number && <th>Số C3D</th>}
              {showColumns.c3d_dob && <th>Ngày sinh</th>}
              {showColumns.c3d_sex && <th>Giới tính</th>}
              {showColumns.c3d_place_of_origin && <th>Nơi sinh</th>}
              {showColumns.c3d_place_of_residence && <th>Nơi cư trú</th>}
              {showColumns.c3d_city && <th>Thành phố</th>}
              {showColumns.c3d_photos && <th>Ảnh C3D</th>}
              {showColumns.c3d_metadata && <th>Metadata C3D</th>}
              {showColumns.address && <th>Địa chỉ</th>}
              {showColumns.phone && <th>Số điện thoại</th>}
              {showColumns.contact_note && <th>Ghi chú liên hệ</th>}
              {showColumns.current_city && <th>Thành phố hiện tại</th>}
              {showColumns.scan_progress && <th>Tiến độ scan ({totalPercentage}%) - {totalMatchingC3DTax}/{totalMatchingC3D}</th>}
              {showColumns.is_deleted && <th>Đã xóa</th>}
              {showColumns.created_at && <th>Ngày tạo</th>}
              {showColumns.updated_at && <th>Ngày cập nhật</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover style={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.MID && <th>MID</th>}
            {showColumns.full_name && <th>Tên đầy đủ</th>}
            {showColumns.full_name_english && <th>Tên tiếng Anh</th>}
            {showColumns.is_registered_etsy && <th>Trạng thái Etsy</th>}
            {showColumns.relation_with && <th>Đầu mối</th>}
            {showColumns.relation_note && <th>Ghi chú quan hệ</th>}
            {showColumns.c3d_number && <th>Số C3D</th>}
            {showColumns.c3d_dob && <th>Ngày sinh</th>}
            {showColumns.c3d_sex && <th>Giới tính</th>}
            {showColumns.c3d_place_of_origin && <th>Nơi sinh</th>}
            {showColumns.c3d_place_of_residence && <th>Nơi cư trú</th>}
            {showColumns.c3d_city && <th>Thành phố</th>}
            {showColumns.c3d_photos && <th>Ảnh C3D</th>}
            {showColumns.c3d_metadata && <th>Metadata C3D</th>}
            {showColumns.address && <th>Địa chỉ</th>}
            {showColumns.phone && <th>Số điện thoại</th>}
            {showColumns.contact_note && <th>Ghi chú liên hệ</th>}
            {showColumns.current_city && <th>Thành phố hiện tại</th>}
            {showColumns.scan_progress && <th>Tiến độ scan ({totalPercentage}%) - {totalMatchingC3DTax}/{totalMatchingC3D}</th>}
            {showColumns.is_deleted && <th>Đã xóa</th>}
            {showColumns.created_at && <th>Ngày tạo</th>}
            {showColumns.updated_at && <th>Ngày cập nhật</th>}
            <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeTrustedPersonInfos.map((info, index) => {
            if (!info || typeof info !== 'object') return null; // Skip if info is undefined/null or not an object
            
            return (
              <tr key={info._id || index}>
                <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                {showColumns.MID && (
                  <td>
                    {info.MID ? (
                      <Badge 
                        bg="primary" 
                        style={{ 
                          fontSize: '0.9em', 
                          padding: '6px 10px',
                          cursor: 'pointer'
                        }}
                        onClick={() => this.openC3DSearchLink(info.full_name_english, info.MID)}
                        title="Tìm kiếm trong C3D Database"
                      >
                        {info.MID}
                      </Badge>
                    ) : '-'}
                  </td>
                )}
                {showColumns.full_name && (
                  <td>
                    <div className="fw-bold">{info.full_name || '-'}</div>
                  </td>
                )}
                {showColumns.full_name_english && (
                  <td>{info.full_name_english || '-'}</td>
                )}
                {showColumns.is_registered_etsy && (
                  <td>
                    <Badge bg={info.is_registered_etsy ? "success" : "secondary"}>
                      {info.is_registered_etsy ? "Đã đăng ký" : "Chưa đăng ký"}
                    </Badge>
                  </td>
                )}
                {showColumns.relation_with && (
                  <td>{info.relation_with || '-'}</td>
                )}
                {showColumns.relation_note && (
                  <td>{info.relation_note || '-'}</td>
                )}
                {showColumns.c3d_number && (
                  <td>
                    {info.c3d_number ? (
                      <div className="d-flex align-items-center gap-2">
                        <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{info.c3d_number}</Badge>
                        <FaCopy 
                          size={12} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(info.c3d_number)}
                          title="Copy C3D number"
                        />
                      </div>
                    ) : '-'}
                  </td>
                )}
                {showColumns.c3d_dob && (
                  <td>{info.c3d_dob || '-'}</td>
                )}
                {showColumns.c3d_sex && (
                  <td>{this.mapGender(info.c3d_sex)}</td>
                )}
                {showColumns.c3d_place_of_origin && (
                  <td>
                    <div style={{ whiteSpace: 'nowrap' }} 
                         title={info.c3d_place_of_origin}>
                      {info.c3d_place_of_origin || '-'}
                    </div>
                  </td>
                )}
                {showColumns.c3d_place_of_residence && (
                  <td>
                    <div style={{ whiteSpace: 'nowrap' }} 
                         title={info.c3d_place_of_residence}>
                      {info.c3d_place_of_residence || '-'}
                    </div>
                  </td>
                )}
                {showColumns.c3d_city && (
                  <td>{info.c3d_city || '-'}</td>
                )}
                {showColumns.c3d_photos && (
                  <td>
                    {info.c3d_photos && info.c3d_photos.length > 0 ? (
                      <Badge bg="info">{info.c3d_photos.length} ảnh</Badge>
                    ) : '-'}
                  </td>
                )}
                {showColumns.c3d_metadata && (
                  <td>
                    {info.c3d_metadata ? (
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={JSON.stringify(info.c3d_metadata)}>
                        <Badge bg="secondary">Có metadata</Badge>
                      </div>
                    ) : '-'}
                  </td>
                )}
                {showColumns.address && (
                  <td>
                    <div style={{ whiteSpace: 'nowrap' }} 
                         title={info.address}>
                      {info.address || '-'}
                    </div>
                  </td>
                )}
                {showColumns.phone && (
                  <td>{info.phone || '-'}</td>
                )}
                {showColumns.contact_note && (
                  <td>
                    <div style={{ whiteSpace: 'nowrap' }} 
                         title={info.contact_note}>
                      {info.contact_note || '-'}
                    </div>
                  </td>
                )}
                {showColumns.current_city && (
                  <td>{info.current_city || '-'}</td>
                )}
                {showColumns.scan_progress && (
                  <td>
                    {info.matching_c3d_total ? (
                      <div className="d-flex align-items-center gap-2">
                        <Badge 
                          bg={
                            this.calculateScanProgress(info.matching_c3d_tax_total, info.matching_c3d_total) === '100%' ? 'success' :
                            this.calculateScanProgress(info.matching_c3d_tax_total, info.matching_c3d_total) === '0%' ? 'secondary' :
                            'warning'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.calculateScanProgress(info.matching_c3d_tax_total, info.matching_c3d_total)}
                        </Badge>
                        <small className="text-muted">
                          ({info.matching_c3d_tax_total || 0}/{info.matching_c3d_total || 0})
                        </small>
                      </div>
                    ) : '-'}
                  </td>
                )}
                {showColumns.is_deleted && (
                  <td>
                    <Badge bg={info.is_deleted ? "danger" : "success"}>
                      {info.is_deleted ? "Đã xóa" : "Hoạt động"}
                    </Badge>
                  </td>
                )}
                {showColumns.created_at && (
                  <td>
                    {info.created_at ? new Date(info.created_at).toLocaleDateString('vi-VN') : '-'}
                  </td>
                )}
                {showColumns.updated_at && (
                  <td>
                    {info.updated_at ? new Date(info.updated_at).toLocaleDateString('vi-VN') : '-'}
                  </td>
                )}
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div style={{ position: 'relative' }}>
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(info)}
                      />
                      {info.last_checked_tax && (
                        <span 
                          style={{
                            position: 'absolute',
                            top: '-4px',
                            right: '-4px',
                            width: '12px',
                            height: '12px',
                            backgroundColor: '#28a745',
                            borderRadius: '50%',
                            border: '2px solid white'
                          }}
                          title="Đã kiểm tra thuế"
                        />
                      )}
                    </div>
                    <FaEdit 
                      size={16} 
                      style={{ 
                        cursor: 'pointer', 
                        color: '#6c757d'
                      }}
                      title="Chỉnh sửa"
                      onClick={() => this.handleEditClick(info)}
                    />
                    {info.full_name_english && (
                      <span 
                        style={{ 
                          cursor: 'pointer', 
                          fontSize: '16px'
                        }}
                        title="Tìm kiếm trong C3D Database"
                        onClick={() => this.openC3DSearchLink(info.full_name_english, info.MID)}
                      >
                        🚀
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            );
          })
        }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Trusted Person
              </h2>
            </Col>
            <Col className="text-end" md="auto">
              <div className="d-flex gap-2">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={this.handleCreateClick}
                  title="Thêm mới Trusted Person"
                >
                  <i className="fas fa-plus me-1"></i>
                  Thêm mới
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => this.setState({ showConfigModal: true })}
                  title="Cấu hình hiển thị"
                >
                  <i className="fas fa-cog me-1"></i>
                  Cấu hình
                </Button>
                <Button
                  variant="success"
                  size="sm"
                  onClick={this.handleUpdateAllTrustedPersonStatus}
                  title="Cập nhật trạng thái cho tất cả Trusted Person"
                >
                  <i className="fas fa-sync-alt me-1"></i>
                  Cập nhật tất cả
                </Button>
              </div>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.renderTrustedPersonTable()}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    MID: 'MID',
                    full_name: 'Tên đầy đủ',
                    full_name_english: 'Tên tiếng Anh',
                    is_registered_etsy: 'Trạng thái Etsy',
                    relation_with: 'Đầu mối',
                    relation_note: 'Ghi chú quan hệ',
                    c3d_number: 'Số C3D',
                    c3d_dob: 'Ngày sinh',
                    c3d_sex: 'Giới tính',
                    c3d_place_of_origin: 'Nơi sinh',
                    c3d_place_of_residence: 'Nơi cư trú',
                    c3d_city: 'Thành phố',
                    c3d_photos: 'Ảnh C3D',
                    c3d_metadata: 'Metadata C3D',
                    address: 'Địa chỉ',
                    phone: 'Số điện thoại',
                    contact_note: 'Ghi chú liên hệ',
                    current_city: 'Thành phố hiện tại',
                    scan_progress: 'Tiến độ scan',
                    is_deleted: 'Đã xóa',
                    created_at: 'Ngày tạo',
                    updated_at: 'Ngày cập nhật'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <TrustedPersonInfoModal
          show={this.state.showViewModal}
          onHide={this.handleCloseViewModal}
          trustedPersonInfo={this.state.selectedTrustedPersonInfo}
          isEditMode={false}
        />

        {/* Edit Modal */}
        <TrustedPersonInfoModal
          show={this.state.showEditModal}
          onHide={this.handleCloseEditModal}
          trustedPersonInfo={this.state.selectedTrustedPersonInfo}
          isEditMode={true}
          isCreateMode={false}
          onSave={this.handleSaveEdit}
        />

        {/* Create Modal */}
        <TrustedPersonInfoModal
          show={this.state.showCreateModal}
          onHide={this.handleCloseCreateModal}
          trustedPersonInfo={this.state.selectedTrustedPersonInfo}
          isEditMode={true}
          isCreateMode={true}
          onSave={this.handleSaveEdit}
          hideStatistics={true}
        />

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={() => this.setState({ 
            showIframeModal: false,
            iframeUrl: '',
            iframeTitle: ''
          })}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    trustedPersonInfos: state.tkt1TrustedPersonReducer.trustedPersonInfos,
    totalCount: state.tkt1TrustedPersonReducer.totalCount
  };
};

export default connect(mapStateToProps, { getTKT1TrustedPersonInfos, updateTKT1TrustedPersonInfo, createTKT1TrustedPersonInfo })(TKT1TrustedPerson);
